import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../utils/response';
import { Token, UserCode, Company, EmployeeId, EmployeeCode, Worksite } from '../../utils/users';
import { GetLanguage } from '../../utils/language';
import { errorResponse } from '../../utils/response';

export function saveTimesheet(id, startDate, endDate, duration, subCode, department, jobTitle, comments, project,
    activityId, activityP, extraTimeBank, extraTimePay, mealAllowance, punchType, startTime, endTime, projectNumber,
    workOrderId, timesheetNight, task, ccqFunctionId, salaryTable, primeIndicator, ccq) {

    const param = JSON.stringify({
        userCode: UserCode(),
        punchTimesheetId: id,
        employeeId: EmployeeId(),
        languageDesc: GetLanguage(),
        startDate: startDate,
        endDate: endDate,
        duration: parseFloat(duration),
        subCode: subCode,
        department: department,
        jobTitle: jobTitle,
        comments: comments,
        project: project === '' ? null : project,
        activityId: activityId === '' ? null : parseInt(activityId),
        activityP: activityP === '' ? null : activityP,
        extraTimeBank: extraTimeBank,
        extraTimePay: extraTimePay,
        mealAllowance: mealAllowance,
        punchType: punchType,
        startTime: startTime,
        endTime: endTime,
        projectNumber: projectNumber === '' ? null : projectNumber,
        workOrderId: workOrderId,
        timesheetNight: timesheetNight,
        task: task,
        ccqFunctionId: ccqFunctionId,
        salaryTable: salaryTable,
        primeIndicator: primeIndicator,
        isCCQ: ccq,
        token: Token()
    });

    return fetch('timesheet/save', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: param
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function deleteTimesheet(id) {
    return fetch('timesheet/delete', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            punchTimesheetId: id,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function readyToApproveTimesheet(status, startDate, endDate) {
    return fetch('timesheet/readyToApprove', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            employeeCode: EmployeeCode(),
            company: Company(),
            status: status,
            startDate: startDate,
            endDate: endDate,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function get(id) {
    let url = 'timesheet/get?' + objectToQueryString({ userCode: UserCode(), timesheetId: id, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listSummary(startDate, endDate) {
    let url = 'timesheet/listSummaryWeek?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeId: EmployeeId(), startDate: startDate, endDate: endDate, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function loadCombos() {
    let url = 'timesheet/combos?' + objectToQueryString(
        {
            company: Company(),
            userCode: UserCode(),
            employeeCode: EmployeeCode(),
            employeeId: EmployeeId(),
            worksite: Worksite(),
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getDuration(date, punchTimesheetId) {
    let url = 'timesheet/getDurationDate?' + objectToQueryString(
        {
            userCode: UserCode(),
            date: date,
            punchTimesheetId: punchTimesheetId,
            employeeCode: EmployeeCode(),
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}